import { Component } from '@angular/core';

@Component({
  selector: 'app-citizen-home-layout',
  templateUrl: './citizen-home-layout.component.html',
})
export class CitizenHomeLayoutComponent {}
